/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Tooltip(theme: Theme): any {
  const isLight = theme.palette.mode === "light";

  return {
    MuiTooltip: {
      styleOverrides: {
        popper: { zIndex: 1700 },
        tooltip: { backgroundColor: theme.palette.grey[isLight ? 800 : 700] },
        arrow: { color: theme.palette.grey[isLight ? 800 : 700] },
      },
    },
  };
}
